import { render, staticRenderFns } from "./NumericColumn.vue?vue&type=template&id=331a4906&scoped=true&"
import script from "./NumericColumn.vue?vue&type=script&lang=js&"
export * from "./NumericColumn.vue?vue&type=script&lang=js&"
import style0 from "./NumericColumn.vue?vue&type=style&index=0&id=331a4906&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331a4906",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('331a4906')) {
      api.createRecord('331a4906', component.options)
    } else {
      api.reload('331a4906', component.options)
    }
    module.hot.accept("./NumericColumn.vue?vue&type=template&id=331a4906&scoped=true&", function () {
      api.rerender('331a4906', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/table/column/NumericColumn.vue"
export default component.exports